import type { CellValue } from "../core/dtype.ts";

/**
 * One task list the user has, as supplied by the app layer. The app
 * resolves these from the server's `:~lona:tasks:lists` enumerator (or
 * any other source) and feeds them to `taskListAliasFactory` so the
 * task-list alias's dynamic tail spawns one `data-source` child per
 * list — the task analog of `CalendarConfigCalendar`.
 *
 * `lookupKey` is the canonical row the spawned child fetches from
 * (e.g. `:~lona:chores`, `:~google:{authId}:tasks:{listId}`).
 */
export interface TaskListConfigItem {
  readonly id: string;
  readonly title: string;
  readonly lookupKey: string;
}

/** Lists the task lists a task-list alias expands into. */
export interface TaskListConfigProvider {
  taskLists(): readonly TaskListConfigItem[];
}

export function taskListConfigCell(item: TaskListConfigItem): CellValue {
  return {
    id: item.id,
    title: item.title,
    lookupKey: item.lookupKey,
  };
}
